import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Filter out harmless Cloudflare Turnstile errors
// These errors occur because Turnstile uses sandboxed iframes for security
// and are expected behavior that doesn't affect functionality
// Note: 400 Bad Request and 401 Unauthorized errors from challenges.cloudflare.com/cdn-cgi/challenge-platform
// typically occur when testing on localhost with a site key configured only for production domain
if (typeof window !== 'undefined') {
  const originalError = console.error;
  const originalWarn = console.warn;

  const isTurnstileError = (...args) => {
    return args.some(arg => {
      if (typeof arg === 'string') {
        return (
          arg.includes("Blocked script execution in 'about:blank'") ||
          arg.includes("document's frame is sandboxed") ||
          arg.includes("allow-scripts' permission is not set") ||
          (arg.includes("challenges.cloudflare.com") && (
            arg.includes("sandboxed") ||
            arg.includes("challenge-platform") ||
            arg.includes("400") ||
            arg.includes("401")
          ))
        );
      }
      // Check for Error objects related to Turnstile
      if (arg instanceof Error) {
        const message = arg.message || '';
        return (
          message.includes("challenges.cloudflare.com") ||
          message.includes("challenge-platform") ||
          ((message.includes("400") || message.includes("401")) && message.includes("cloudflare"))
        );
      }
      return false;
    });
  };

  console.error = (...args) => {
    if (!isTurnstileError(...args)) {
      originalError.apply(console, args);
    }
  };

  console.warn = (...args) => {
    if (!isTurnstileError(...args)) {
      originalWarn.apply(console, args);
    }
  };

  // Handle unhandled promise rejections from Turnstile
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (reason && typeof reason === 'object') {
      const message = reason.message || reason.toString() || '';
      const url = reason.url || '';
      
      // Suppress Turnstile-related network errors (400/401 from localhost domain mismatch)
      if (
        (message.includes("challenges.cloudflare.com") ||
         message.includes("challenge-platform") ||
         url.includes("challenges.cloudflare.com")) &&
        (message.includes("400") || message.includes("401") || 
         message.includes("Bad Request") || message.includes("Unauthorized"))
      ) {
        event.preventDefault(); // Prevent default error logging
        return;
      }
    }
  });
}

// Initialisiere Tracking-Scripts beim App-Start (wenn Consent vorhanden)
import { initializeTrackingScripts } from "./utils/cookieConsent";
initializeTrackingScripts();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
